module.exports = __webpack_public_path__ + "img/爱奇艺_04.159e0ad3.jpg";